import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RealEstateListPage } from './realestate-list.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'realestate',
    component: RealEstateListPage,
    canActivate: [authGuard, hasRoleGuard(null, ['read_realestate'])],
    data: {
      title: "Lista de propiedades"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RealEstateListPageRoutingModule { }
